import { AuctionIcon } from "components/icons";
import { PERMISSION } from "../constants";
import { APP_PATH } from "constants/path";
import React from "react";
import { lazyRetry } from "utils/route";
import { isProd } from "utils/environment";

const Autions = React.lazy(() =>
	lazyRetry(() => import("../features/auction/AuctionList")),
);
const AutionDetail = React.lazy(() =>
	lazyRetry(() => import("../features/auction/AuctionDetail")),
);

const auctionRoutes = [
	{
		label: "Auctions",
		icon: <AuctionIcon className="w-4 h-4" />,
		path: APP_PATH.auctions,
		key: "auctions",
		component: <Autions />,
		permissions: [PERMISSION.AUCTION.VIEW],
	},
	{
		label: "Auction details",
		path: `${APP_PATH.auctions}/:id`,
		key: "auctions",
		hidden: true,
		component: <AutionDetail />,
		permissions: [PERMISSION.AUCTION.VIEW],
	},
];

export default auctionRoutes;
